"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importDefault(require("react"));
var slate_1 = require("slate");
var slate_react_1 = require("slate-react");
var styles_1 = require("@material-ui/core/styles");
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var ActionButtons_1 = __importDefault(require("../../../ActionButtons"));
var Button_1 = __importDefault(require("../../../Button"));
exports.useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            position: 'relative',
            backgroundColor: '#F0F4F8',
            borderRadius: theme.shape.borderRadius,
            padding: theme.spacing(1),
            marginBottom: theme.spacing(2),
        },
        field: {
            display: 'flex',
            alignItems: 'center',
            background: 'transparent',
            boxShadow: 'none',
            width: '100%',
            textAlign: 'center',
            resize: 'none',
            outline: 'none',
            padding: 16,
            height: 54,
            fontSize: '16px',
            boxSizing: 'border-box',
            border: '2px solid #D9E2EC',
            borderRadius: 2,
        },
        caption: {
            fontSize: '12px',
            textAlign: 'center',
            margin: theme.spacing(1, 0),
        },
    });
});
var EditorEmbedMedia = function (_a) {
    var attributes = _a.attributes, description = _a.description, children = _a.children, type = _a.type, element = _a.element, other = __rest(_a, ["attributes", "description", "children", "type", "element"]);
    var classes = exports.useStyles();
    var editor = slate_react_1.useEditor();
    var path = slate_react_1.ReactEditor.findPath(editor, element);
    function handleSave() {
        slate_1.Transforms.setNodes(editor, {
            type: type,
        }, { at: path });
    }
    function handleCancel() {
        slate_1.Transforms.setNodes(editor, {
            type: 'paragraph',
        }, { at: path });
    }
    return (react_1.default.createElement("div", __assign({}, attributes, { className: classes.root }, other),
        react_1.default.createElement("div", { className: classes.field }, children),
        react_1.default.createElement("div", { contentEditable: false },
            react_1.default.createElement(Typography_1.default, { color: "textSecondary", className: classes.caption }, "Paste URL above"),
            description && (react_1.default.createElement(Typography_1.default, { color: "textSecondary", className: classes.caption }, description)),
            react_1.default.createElement(ActionButtons_1.default, { align: "center" },
                react_1.default.createElement(Button_1.default, { size: "small", variant: "text", color: "primary", 
                    // disabled={!value}
                    onClick: handleSave }, "Save"),
                react_1.default.createElement(Button_1.default, { size: "small", variant: "text", onClick: handleCancel }, "Cancel")))));
};
exports.default = EditorEmbedMedia;
//# sourceMappingURL=EditorEmbedMedia.js.map